gsap.registerPlugin(ScrollTrigger);
const items = gsap.utils.toArray(".js-mv");
// 各要素に対してアニメーションを設定
items.forEach((item) => {
  gsap.fromTo(
    item.querySelector("img"), // アニメーションを適用する画像要素を取得
    {
      yPercent: 0, // パララックス前の要素の位置
    }, {
      yPercent: -20, // 上に要素の幅の1/5分移動
      ease: "none", // イージングなし
      scrollTrigger: {
        trigger: item, // アニメーションのトリガー要素
        start: "top bottom", // アニメーション開始位置
        end: "bottom top", // アニメーション終了位置
        scrub: 1, // 動作を遅らせる
      },
    }
  );
});



gsap.registerPlugin(ScrollTrigger);
gsap.utils.toArray('.js-parallax').forEach(wrap => {
  const y = wrap.getAttribute('data-y') || -100;

  gsap.to(wrap, {
    y: y,
    scrollTrigger: {
      trigger: wrap,
      start: 'top bottom',
      end: 'bottom top',
      scrub: 0.5
      //markers: true
    }
  });
});

const contents = document.querySelectorAll(".js-trigger");
for (const content of contents) {
  content.imgs = content.querySelectorAll(".js-item");
  gsap.to(content.imgs, {
    opacity: 1,
    duration: 0.6,
    stagger: 0.3,
    ease: "power2.out",
    yPercent: 10,
    scrollTrigger: {
      //markers: true,
      trigger: content,
      start: "top 60%",
    },
  });
}

gsap.utils.toArray(".js-fadeIn").forEach(function(target) {
  gsap.from(target, {
    scrollTrigger: {
      trigger: target,
    },
    duration: 0.8,
    delay: 0.4,
    opacity: 0,
    y: 100,
    ease: "power2.out",
    scale: 1,
  });
});

/* gsap.from('.js-fadeIn', {
     duration: 0.8,
     delay: 0.5,
     opacity: 0,
     y: 100,
     ease: "power2.out",
     scale: 1,
     scrollTrigger: {
       trigger: '.js-fadeIn',
       markers: true,
     },
   });*/

$(window).resize(function() {
  //windowの幅をxに代入
  var x = $(window).width();
  //windowの分岐幅をyに代入
  var y = 1060;
  if (x <= y) {
    $('.p-header__nav-list li a').addClass('sp-action')
  } else {
    $('.p-header__nav-list li a').removeClass('sp-action');
  }
});